module.exports = __webpack_public_path__ + "img/Hos_anzhen.cdc94b2e.png";